export default __webpack_public_path__ + "static/media/SOAK.39f5a5fb.png";